import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import classes from "../../../../components/DownloadReportButton/styles.module.css";

export const CompanionApp = () => {
	const { t } = useTranslation();

	return (
		<Box sx={{ display: "flex", gap: "16px", p: 0 }}>
			<a
				className={classes.downloadLink}
				href="/CARGOseller_desktop.exe"
				download={true}
				style={{
					textDecoration: "none",
					textTransform: "uppercase",
				}}
			>
				{t("download_companion")}
			</a>
			{/* <Button
				variant="contained"
				href="https://youtu.be/XqXlC7Ce7u8" // todo: change URL
				target="_blank"
				rel="noreferrer"
				sx={{
					background: "#e0e0e0",
					color: "#121212",
					"&:hover": {
						background: "#c9c9c9",
					},
					display: "flex",
					alignItems: "center",
					gap: "4px",
				}}
			>
				<SlowMotionVideoIcon />
				{t("video_instruction_n_min", { value: 5 })}
			</Button> */}
		</Box>
	);
};
